import RoleDialog from './role';

export default () => (
  <>
    <RoleDialog />
  </>
);
